import clsx from 'clsx';

import { bannerContainerClasses } from '../classes';

export const ContractEndorsementBannerLoading = () => {
  return (
    <div role="status" aria-busy="true" aria-live="polite" className={clsx(bannerContainerClasses(), 'animate-pulse')}>
      <div className="bg-primary-200 h-5 w-5 rounded-full" />
      <div className="bg-primary-200 h-3 w-72 rounded-md" />
      <div className="bg-primary-200 h-3 w-32 rounded-md" />
    </div>
  );
};
